import { DiceType } from '../../../api/DnD/dices';
import { DiceDescription, DiceInfo, DiceOptions } from '../diceTypes';
import { FACE_TEXTS } from '../r3fConstants';
import { createGeometry, createShape } from '../utils';

const createDescription = (): DiceDescription => {
  const vertices: [number, number, number][] = [];
  for (let i = 0, b = 0; i < 10; ++i, b += (Math.PI * 2) / 10) {
    vertices.push([Math.cos(b), Math.sin(b), 0.105 * (i % 2 ? 1 : -1)]);
  }
  vertices.push([0, 0, -1]);
  vertices.push([0, 0, 1]);

  const desc: DiceDescription = {
    type: DiceType.d10,
    tab: 0,
    af: (Math.PI * 6) / 5,
    // chamfer: 0.945,
    chamfer: 1,
    vertices,
    faces: [
      [1, 3, 11, 0],
      [6, 4, 10, 1],
      [7, 9, 11, 2],
      [2, 0, 10, 3],
      [3, 5, 11, 4],
      [0, 8, 10, 5],
      [5, 7, 11, 6],
      [4, 2, 10, 7],
      [9, 1, 11, 8],
      [8, 6, 10, 9],
      [1, 0, 2, -1],
      [1, 2, 3, -1],
      [3, 2, 4, -1],
      [3, 4, 5, -1],
      [5, 4, 6, -1],
      [5, 6, 7, -1],
      [7, 6, 8, -1],
      [7, 8, 9, -1],
      [9, 8, 0, -1],
      [9, 0, 1, -1],
    ],
    scaleFactor: 0.9,
    values: 10,
    faceTexts: FACE_TEXTS,
    textMargin: 1.0,
    mass: 350,
  };

  return desc;
};

const description = createDescription();

const options: DiceOptions = {
  size: 2.5,
  backColor: '#2d3047',
  fontColor: '#ffffff',
};

export const D10: DiceInfo = {
  description,
  options,
  geometry: createGeometry(options.size, description),
  args: createShape(description, options.size),
};
